import React from 'react';
import tri_be_logo from '../assets/logo-green.png';

const Logo = () => (<img id="logo" alt='profile' src={tri_be_logo}/>);

export default Logo;